import { useState, useEffect } from "react";
import { useDispatch } from "react-redux";

const useQuestion = () => {
  const dispatch = useDispatch();
  const [config, setConfig] = useState(null);

  useEffect(() => {
    if (config) {
      const buttons =
        config &&
        config.buttons &&
        config.buttons.map((button, index) => {
          return {
            title: button.text,
            main: index === 0,
            onClick: () => {
              dispatch({
                type: "TOGGLE_REACT_PRETTY_ALERT",
                open: false
              });
              if (button.callback) button.callback();
            }
          };
        });

      dispatch({
        type: "TOGGLE_REACT_PRETTY_ALERT",
        properties: {
          title: config.title,
          message: config.message,
          open: true,
          type: "question",
          stacktrace: null,
          buttons
        }
      });
    }

    setConfig(null); // Limpa a propriedade para não repetir a mensagem.
  }, [config, dispatch]);

  return ({ title, message, buttons }) =>
    setConfig({ title, message, buttons });
};

export default useQuestion;
